import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_credit_note = async (creditNote) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-credit-note`, creditNote, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_credit_note = async (creditNote) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-credit-note`, creditNote, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_credit_notes = async (filters) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-all-credit-notes`, filters, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_credit_notes_by_invoice = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-credit-notes-by-invoice`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const delete_credit_note = async (creditNote) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/delete-credit-note`, creditNote, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_credit_note,
  get_credit_note,
  get_all_credit_notes,
  get_credit_notes_by_invoice,
  delete_credit_note,
};